import { render, staticRenderFns } from "./novice-dialog.vue?vue&type=template&id=e17ed750&scoped=true&"
import script from "./novice-dialog.vue?vue&type=script&lang=ts&"
export * from "./novice-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./novice-dialog.vue?vue&type=style&index=0&id=e17ed750&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17ed750",
  null
  
)

export default component.exports